import React, { FC } from 'react';
import { Label, Dropdown } from '@silverfort/sf-components';

interface Option {
    title: string;
    value: string;
}

interface AdUserIdentifierFieldProps {
    label?: string;
    mandatory?: boolean;
    labelClassName?: string;
    selectedOption: string;
    onChange: (value: string) => void;
    containerClassName?: string;
    options: Option[];
}

const UserIdentifierDropdown: FC<AdUserIdentifierFieldProps> = ({
    label = '',
    mandatory = false,
    labelClassName = 'w-[245px]',
    selectedOption,
    onChange,
    containerClassName = '',
    options
}) => {
    return (
        <div className={`flex items-center gap-2 h-10 ${containerClassName}`}>
            <Label text={label} mandatory={mandatory} className={labelClassName} />
            <Dropdown
                variant="trigger"
                text="Select identifier"
                items={options}
                selectedItems={selectedOption}
                // @ts-ignore: The onChange handler in the Dropdown component provides a parameter of type T | T[] | undefined, which is not compatible with the expected type string.
                onChange={onChange}
            />
        </div>
    );
};

export default UserIdentifierDropdown;
